import PropTypes from "prop-types";

export const AccentHotPink = ({ children }) => {
  return <span className="accent-hot-pink">{children}</span>;
};

AccentHotPink.propTypes = {
  children: PropTypes.node,
};
